import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

export default function FleetSection() {
  const { ref: leftRef, isVisible: leftVisible } = useScrollAnimation();
  const { ref: rightRef, isVisible: rightVisible } = useScrollAnimation();

  return (
    <section className="py-16 lg:py-24 bg-white overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div
            ref={leftRef}
            style={{
              opacity: leftVisible ? 1 : 0,
              transform: leftVisible ? 'translateX(0)' : 'translateX(-50px)',
              transition: 'opacity 0.8s cubic-bezier(0.22, 1, 0.36, 1), transform 0.8s cubic-bezier(0.22, 1, 0.36, 1)',
            }}
          >
            <div className="inline-block bg-brand-red-light text-brand-red px-4 py-2 rounded-full text-sm font-semibold mb-6">
              TRUSTED ACROSS FLORIDA
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 mb-4 lg:mb-6 leading-tight">
              Our Fleet Is Ready To Serve Your Home
            </h2>
            <p className="text-base lg:text-lg text-gray-600 mb-6 lg:mb-8">
              With a fleet of fully‑equipped service vehicles across Florida, our certified technicians are always nearby and ready to deliver expert HVAC, solar, and insulation solutions right to your doorstep.
            </p>
            <div className="grid grid-cols-2 gap-3 sm:gap-6 mb-6 lg:mb-8">
              <div className="bg-brand-cream rounded-2xl p-4 sm:p-6">
                <div className="text-2xl sm:text-3xl font-bold text-brand-navy mb-1">50+</div>
                <div className="text-xs sm:text-sm text-gray-600">Service Vehicles</div>
              </div>
              <div className="bg-brand-cream rounded-2xl p-4 sm:p-6">
                <div className="text-2xl sm:text-3xl font-bold text-brand-navy mb-1">200+</div>
                <div className="text-xs sm:text-sm text-gray-600">Certified Technicians</div>
              </div>
              <div className="bg-brand-cream rounded-2xl p-4 sm:p-6">
                <div className="text-2xl sm:text-3xl font-bold text-brand-red mb-1">Same Day</div>
                <div className="text-xs sm:text-sm text-gray-600">Service Available</div>
              </div>
              <div className="bg-brand-cream rounded-2xl p-4 sm:p-6">
                <div className="text-2xl sm:text-3xl font-bold text-brand-red mb-1">24/7</div>
                <div className="text-xs sm:text-sm text-gray-600">Emergency Support</div>
              </div>
            </div>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 bg-brand-red text-white px-8 py-4 rounded-full font-semibold hover:bg-brand-red-dark transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line"></i>
              Schedule Service Today
            </a>
          </div>

          <div
            ref={rightRef}
            className="relative"
            style={{
              opacity: rightVisible ? 1 : 0,
              transform: rightVisible ? 'translateX(0)' : 'translateX(50px)',
              transition: 'opacity 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.2s, transform 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.2s',
            }}
          >
            <div className="w-full h-[300px] sm:h-[400px] lg:h-[450px] rounded-3xl overflow-hidden bg-brand-cream flex items-center justify-center">
              <img
                src="https://static.readdy.ai/image/73df10f1d2f13e308059e9f42ef7d721/6f6502536c304c32f5e0d536c1f65fb4.jpeg"
                alt="United States Home Solutions Service Truck"
                className="w-full h-full object-contain"
              />
            </div>
            <div className="absolute -bottom-3 -right-3 sm:-bottom-4 sm:-right-4 bg-brand-navy text-white rounded-2xl p-4 sm:p-6 shadow-xl max-w-[220px] sm:max-w-none">
              <div className="flex items-center gap-2 sm:gap-3">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-white/20 rounded-xl flex-shrink-0">
                  <i className="ri-truck-line text-xl sm:text-2xl text-white"></i>
                </div>
                <div>
                  <div className="font-bold text-sm sm:text-lg">Serving All of Florida</div>
                  <div className="text-white/80 text-xs sm:text-sm">From Miami to Jacksonville</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
